module.exports = __webpack_public_path__ + "files/6f6b255850a453af4b3207bdc0f97db9.png";